import React from 'react';
import {getMobileOperatingSystem, OS} from "../../../../../utils/CheckPlatform";
import {LinkProvider} from "../../../../../res/LinkProvider";
import {Reference} from "../../../../../res/Reference";

interface States {

}

interface Props {
}

class DownloadButton extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        const downloadLink = () => {
            switch (getMobileOperatingSystem()) {
                case OS.android:
                    return LinkProvider.latestAndroidApp
                case OS.iOS:
                    return LinkProvider.latestIosApp
                case OS.unknow:
                    return "#" + Reference.downloadAppSection
            }
        }

        return (
            <div>
                <a
                    href={downloadLink()}>
                    <button
                        className="downloadButton"
                    >
                        Download
                    </button>
                </a>
            </div>
        )
    }
}

export default DownloadButton;
